// Dialoge: ein Link oder Knopf mit data-dialog="<id>" öffnet das <dialog> dieser id als
// Modal, etwa den Melden-Dialog. Ohne JavaScript führt der Link zur eigenen Seite mit
// demselben Formular. Escape, „Abbrechen“ (formmethod="dialog") und ein Klick neben den
// Dialog schließen ihn; der Fokus kehrt zum Auslöser zurück.
//
// Ein Dialog für viele Zeilen (Melden je Domain): der Auslöser trägt in data-dialog-fill,
// was er meldet ({"object": …, "value": …}) - die Felder des Dialogs mit data-dialog-field
// bekommen diese Werte, bevor er aufgeht.
export default function dialogs() {
  const openers = new WeakMap();

  document.querySelectorAll('[data-dialog]').forEach(function (trigger) {
    const dialog = document.getElementById(trigger.dataset.dialog);
    if (!(dialog instanceof HTMLDialogElement)) return;

    trigger.addEventListener('click', function (event) {
      event.preventDefault();
      if (trigger.dataset.dialogFill) fill(dialog, JSON.parse(trigger.dataset.dialogFill));
      openers.set(dialog, trigger);
      dialog.showModal();
    });

    if (dialog.dataset.dialogReady) return;
    dialog.dataset.dialogReady = '1';
    dialog.addEventListener('close', function () {
      const opener = openers.get(dialog);
      if (opener) opener.focus();
    });
    // Klick auf den Hintergrund: Ziel ist der Dialog selbst, die Stelle liegt außerhalb.
    // Tastatur-Klicks auf Knöpfe darin haben den Knopf als Ziel.
    dialog.addEventListener('click', function (event) {
      if (event.target !== dialog) return;
      const box = dialog.getBoundingClientRect();
      const inside = event.clientX >= box.left && event.clientX <= box.right && event.clientY >= box.top && event.clientY <= box.bottom;
      if (!inside) dialog.close();
    });
  });
}

function fill(dialog, values) {
  dialog.querySelectorAll('[data-dialog-field]').forEach(function (field) {
    if (!(field.dataset.dialogField in values)) return;
    const value = values[field.dataset.dialogField] ?? '';
    if (field instanceof HTMLInputElement || field instanceof HTMLSelectElement || field instanceof HTMLTextAreaElement) {
      field.value = String(value);
    } else {
      field.textContent = String(value);
    }
  });
}
